import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useKudosOrdersCountQuery = createQueryHook(KudosApiClient.getKudosOrdersCount, {
  queryKey: ['kudosOrdersCount'],
})
